import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=7e381522&scoped=true"
import script from "./UserSelector.vue?vue&type=script&lang=ts"
export * from "./UserSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e381522",
  null
  
)

export default component.exports